import { useState, useEffect } from 'react';
import axios from 'axios';
import AdminBackButton from '../components/AdminBackButton';

const API_URL = '/backend/api/';

function AdminController() {
  const [roundsTotal, setRoundsTotal] = useState(8);
  const [roundStatuses, setRoundStatuses] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const fetchStatus = async () => {
    try {
      const res = await axios.get(`${API_URL}get_quiz_status.php`);
      if (res.data.success) {
        setRoundsTotal(res.data.rounds_total);
        setRoundStatuses(res.data.round_statuses || {});
      } else {
        setError(res.data.message || 'Fout bij ophalen');
      }
    } catch (err) {
      setError('Kon quiz status niet ophalen');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStatus();
  }, []);

  const setStatus = async (round, status) => {
    setRoundStatuses(prev => ({ ...prev, [round]: status }));

    try {
      await axios.post(`${API_URL}set_round_status.php`, {
        round_number: round,
        status: status
      });
      fetchStatus(); // Altijd refreshen voor juiste data
    } catch (err) {
      setError('Kon status niet opslaan');
      fetchStatus();
    }
  };

  if (loading) return <div className="p-8 text-center text-xl">Laden...</div>;
  if (error) return <div className="p-8 text-center text-red-600 text-xl">{error}</div>;

  return (
    <div className="min-h-screen bg-gray-100 p-8">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-4xl font-bold text-center mb-12">Ronde Controller</h1>
        <AdminBackButton />

        <div className="grid gap-6">
          {Array.from({ length: roundsTotal }, (_, i) => i + 1).map(round => {
            const currentStatus = roundStatuses[round] || 'inactive';

            return (
              <div key={round} className="bg-white rounded-xl shadow-lg p-6 flex items-center justify-between">
                <h2 className="text-2xl font-bold">Ronde {round}</h2>

                <div className="flex items-center gap-4">
                  <button
                    onClick={() => setStatus(round, 'inactive')}
                    className={`px-6 py-3 rounded-lg font-bold text-white transition ${
                      currentStatus === 'inactive'
                        ? 'bg-gray-700'
                        : 'bg-gray-500 hover:bg-gray-600'
                    }`}
                  >
                    Inactive
                  </button>

                  <button
                    onClick={() => setStatus(round, 'active')}
                    className={`px-6 py-3 rounded-lg font-bold text-white transition ${
                      currentStatus === 'active'
                        ? 'bg-green-600'
                        : 'bg-green-400 hover:bg-green-500'
                    }`}
                  >
                    Actief
                  </button>

                  <button
                    onClick={() => setStatus(round, 'finished')}
                    className={`px-6 py-3 rounded-lg font-bold text-white transition ${
                      currentStatus === 'finished'
                        ? 'bg-orange-600'
                        : 'bg-orange-400 hover:bg-orange-500'
                    }`}
                  >
                    Afgesloten
                  </button>

                  <button
                    onClick={() => setStatus(round, 'scored')}
                    className={`px-6 py-3 rounded-lg font-bold text-white transition ${
                      currentStatus === 'scored'
                        ? 'bg-blue-600'
                        : 'bg-blue-400 hover:bg-blue-500'
                    }`}
                  >
                    Nagekeken
                  </button>

                  <span className="ml-8 text-xl font-semibold">
                    Status: <strong className="capitalize">{currentStatus}</strong>
                  </span>
                </div>
              </div>
            );
          })}
        </div>

        <div className="mt-12 text-center">
          <button
            onClick={fetchStatus}
            className="bg-gray-700 hover:bg-gray-800 text-white px-8 py-4 rounded-lg font-bold text-lg"
          >
            Vernieuwen
          </button>
        </div>
      </div>
    </div>
  );
}

export default AdminController;